/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./OverviewGreenPower.vue?vue&type=template&id=25229aca&scoped=true&"
import script from "./OverviewGreenPower.vue?vue&type=script&lang=js&"
export * from "./OverviewGreenPower.vue?vue&type=script&lang=js&"
import style0 from "./OverviewGreenPower.vue?vue&type=style&index=0&id=25229aca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25229aca",
  null
  
)

export default component.exports